// extracted by css-extract-rspack-plugin
export default {"yellow":"yellow-c5MpqF","wrapper":"wrapper-iSijz3","pagination":"pagination-Jk3Jnk","action":"action-zUWgK7","information":"information-n4O9QY","prev":"prev-a_N7rj"};